module.exports = "/images/vendor/flag-icon-css/flags/1x1/pr.svg?1d278b022fba04fb58b4ed40b7562ae0";